module.exports = __webpack_public_path__ + "media/images/ok-icon-big-ac0a62bafa99400aa19c449c96adfca1.png";